export const MASTER_KEY = String(import.meta.env.VITE_MASTER_KEY)
export const API_URL = String(import.meta.env.VITE_API_URL)
export const WS_API_URL = String(API_URL.replace('0.0.0.0', 'localhost'))
export const BUILD_TYPE = String(import.meta.env.VITE_BUILD_TYPE)
export const FIREBASE_CONFIG = import.meta.env.VITE_FIREBASE_CONFIG
export const POSTHOG_KEY = String(import.meta.env.VITE_POSTHOG_KEY ?? '')
export const USE_TRANSLATIONS = true
export const PORTAL_DOMAIN = String(import.meta.env.VITE_PORTAL_DOMAIN)
export const APP_ENV = String(import.meta.env.VITE_ENV ?? 'development')
export const IS_PROD = APP_ENV === 'production'

export const IS_IN_LOCAL = import.meta.env.MODE === 'development'
export const LOGGER_ENABLED = import.meta.env.MODE === 'development'
